/** Mensagem amigável para qualquer erro vindo do núcleo (inclui validação Zod). */
export function mensagemErro(e: unknown): string {
  const err = e as { name?: string; message?: string; issues?: Array<{ message?: string }> }
  if (Array.isArray(err?.issues) && err.issues[0]?.message) return err.issues[0].message
  if (err?.name === 'ZodError' && err.message) {
    try {
      const lista = JSON.parse(err.message) as Array<{ message?: string }>
      if (lista[0]?.message) return lista[0].message
    } catch {
      /* mensagem não era JSON */
    }
  }
  return err?.message || 'Algo deu errado.'
}
